import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import { appService } from '../../_services';
import { MdCancel } from "react-icons/md"

var count = 0;
var authList = [];


var Searchborderzero = {
    borderBottom: '0px'
}


export class MultiSelectCheckbox extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.state = { ShowDropdown: false };
        this.state = { searchtextboxvalue: '' };
        this.state = { ShowCrossButton: false };
        this.state = { authorName: "",page: 1, scrollTop: 0 };
        
        this.state = { ClearAll: false };

        this.state = { items: [], list: [], defaultList: [] }

        //this.state = {
        //    list: [
        //        { id: 1, name: "One", isChecked: false },
        //        { id: 2, name: "Two", isChecked: false },
        //        { id: 3, name: "Three", isChecked: false },
        //        { id: 4, name: "Four", isChecked: false },
        //        { id: 5, name: "Five", isChecked: false },
        //        { id: 6, name: "Six", isChecked: false },
        //    ],
        //  items: []
        //}
        this.filterList = this.filterList.bind(this);
        this.HandleButtonClick = this.HandleButtonClick.bind(this);
        this.ClearFun = this.ClearFun.bind(this);
        this.handlecheckChange = this.handlecheckChange.bind(this);
        this.ClearSearchBox = this.ClearSearchBox.bind(this);
    }

    clearall(e) {
        this.ClearFun(e);
    }

    ClearSearchBox(event) {
        this.setState({ searchtextboxvalue: '' });
        var updatedList = this.state.list;

        this.setState({ items: updatedList });
    }

    removeRegex(title) {
        let regex = /(<([^>]+)>)/ig;
        let body = title;
        return body.replace(regex, "");
    } 
    

    updateAuthorCount = (e) => {
        this.props.SearchCallback(authList);
    }

    HandleButtonClick = (e) => {
        this.setState({
            ShowDropdown: !this.state.ShowDropdown

        });
    }

    handlecheckChange(evt) {

        if (evt.target.checked === true) {
            count = count + 1;
            authList.push(evt.target.value);                
        }
        else {
            count = count - 1;            
            var array = authList; // make a separate copy of the array
            var index = array.indexOf(evt.target.value)
            if (index !== -1) {
                array.splice(index, 1);
                authList = array;
            }
        }
        this.state.items.find(item => item.name === evt.target.name).isChecked = evt.target.checked;
        if (count === 0) {
            this.setState({
                ClearAll: false
            });
        }
        else {
            this.setState({
                ClearAll: true
            });
        }

        let list = this.state.list;
        if (list.find(item => item.name === evt.target.name) != undefined)
        {
            list.find(item => item.name === evt.target.name).isChecked = evt.target.checked;
        }
        else
        {
            var author = { id: evt.target.id.replace("auth_",""), isChecked: evt.target.checked, name: evt.target.name, value: evt.target.value};
            list.unshift(author);
        }
        
        if (count === 0) {
            let dflist = this.state.defaultList.slice();
            this.setState({ items: dflist });
            this.setState({ list: dflist });
        }
        else {
            this.setState({ list: list });
        }

        this.updateAuthorCount()
    }


    ClearFun(evt) {
        
        count = 0;
        authList = [];
        let list = this.state.list;
        list.forEach(item => {
            item.isChecked = false;
        });
        this.state.items.forEach(item => {
            item.isChecked = false;
        });
        let dflist = this.state.defaultList.slice();
        this.state.items = dflist;
        this.state.list = dflist;
        this.setState({ searchtextboxvalue: "", page: 1 });  
        this.setState({
            ClearAll: false
        });
        //this.setState({ items: dflist });
        //this.setState({ list: dflist });
        //this.setState({ page: 1 });        
        this.updateAuthorCount();
    }

    onScroll = (event) => {
        const target = event.target;
        const scrollY = window.scrollY; //Don't get confused by what's scrolling - It's not the window
        const scrollTop = this.myRef.current.scrollTop;
        if (target.scrollHeight - target.scrollTop <= target.clientHeight + 8 && this.state.searchtextboxvalue != "") {
            var self = this;
            var url = 'Product/GetAuthors?str=' + self.state.searchtextboxvalue + '&page=';
            self.state.page = self.state.page + 1;
            appService.getById(url, self.state.page)
                .then(function (data) {                    
                    self.setState({ items: Object.values(data) });
                    target.scrollTop = 520 * (self.state.page -1);
                    //self.setState({ list: Object.values(data) });
                });
        }
        //console.log(`onScroll, window.scrollY: ${scrollY} myRef.scrollTop: ${scrollTop}`)
        //this.setState({
        //    scrollTop: scrollTop
        //})
    }

    renderList = () => {
        return this.state.items != null && this.state.items.map(item =>
            <div className="css-1vr111p-option" key={item.id}>
                <div className="square">
                    <input key={item.id} id={"auth_" + item.id} style={{ marginRight: '8px', display: 'inline-block' }} type="checkbox" name={this.removeRegex(item.name)} value={item.value} checked={item.isChecked} onChange={this.handlecheckChange} />
                    <label style={{ fontSize: '13px' }} htmlFor={"auth_" + item.id}>
                    </label>
                    <span style={{ fontSize: '13px' }}>{item.name}</span>
                </div>
            </div>
        )
    }

    filterList(event) {
        this.myRef.current.scrollTop = 0;
        if (event.target.value.length >= 3) {
            var self = this;
            var url = 'Product/GetAuthors?str=' + event.target.value + '&page=';
            self.state.page = 1;
            appService.getById(url, self.state.page)
                .then(function (data) {
                    var filtList = Object.values(data);
                    var checkdata = self.state.list.filter(e => e.isChecked == true);
                    for (var i = 0; i < checkdata.length; i++) {
                        if (typeof filtList.find(item => item.name === checkdata[i].name) != 'undefined') {
                            filtList.find(item => item.name === checkdata[i].name).isChecked = true;
                        }
                    }
                    self.setState({ items: filtList });
                    //self.setState({ list: Object.values(data) });
                });
        }
        else if (event.target.value.length < 3) {
            this.setState({ items: this.state.list });
        }
        //var updatedList = this.state.list;
        //updatedList = updatedList.filter(function (item) {
        //    return item.name.toLowerCase().search(
        //        event.target.value.toLowerCase()) !== -1;
        //});
        //this.setState({ items: updatedList });

        if (event.target.value !== "") {
            this.setState({ ShowCrossButton: true });
            this.setState({ searchtextboxvalue: event.target.value })
        }
        else {
            this.setState({ ShowCrossButton: false })
            this.setState({ searchtextboxvalue: event.target.value })
            this.setState({ items: this.state.list });
            this.setState({ items: this.state.list });
            this.setState({ page: 1 });
            
        }

    }

    componentWillMount() {
        this.setState({ items: this.state.list })
    }    

    componentWillReceiveProps(nextProps) {

        if (nextProps.AuthorName != undefined && nextProps.AuthorName != "" ) {
            
            if (this.state.items.filter(data => data.value == nextProps.AuthorName).length > 0) {
                this.state.items.filter(data => data.value == nextProps.AuthorName)[0].isChecked = true;
            }
            else
            {
                var self = this;
                appService.getById('Product/GetAuthorDetails?authoName=', nextProps.AuthorName)
                    .then(function (data) {
                        data.isChecked = true;
                        self.state.items.unshift(data);
                        //self.setState({ items: Object.values(data) });
                        //self.setState({ list: Object.values(data) });
                    });
            }

            if (authList.indexOf(nextProps.AuthorName) === -1)
            {
                authList.push(nextProps.AuthorName);
                count = count + 1;
                //window['SearchAuthor'] = '';
            }
        }
    }

    componentDidMount() {

        var self = this;
        appService.getAll('Product/GetAllAuthors')
            .then(function (data) {
                self.setState({ items: Object.values(data) });
                self.setState({ list: Object.values(data) });
                self.setState({ defaultList: Object.values(data) });                
            });

    }

    render() {

        //if(this.state.authorName != "")
        //{
        //    let data = this.state.items;
        //    this.state.items.filter(data => data.name == this.state.authorName)[0].isChecked = true;
        //    //var rec = data.filter(data => data.name == this.state.authorName);
        //    //data.filter(data => data.name == this.state.authorName).isChecked = true;
        //}

        return (
            <div>
                <div style={{ position: 'relative' }}>
                    <button type="button" className="css-1r4vtzz" onClick={this.HandleButtonClick} style={!this.state.ShowDropdown ? null : Searchborderzero}>                        
                        <span className="css-1gpjby2" style={{ float: 'right' }}>
                            {(this.state.ShowDropdown == true) ?
                                <i className="fa fa-caret-up caret float-none" style={{ marginLeft: '1px' }}>
                                </i>
                                :
                                <i className="fa fa-caret-down caret float-none" style={{ marginLeft: '1px' }}>
                                </i>
                            }
                        </span>
                        <span className="css-1v99tuv" style={{ verticalAlign: 'middle' }}> {count !== 0 ? "(" + count + ")" : "Author"}
                                {(this.state.ClearAll == true) ?
                                <span className="LinkClass" style={{ float: 'right' }} onClick={this.ClearFun}>Clear</span>
                                :
                                null
                            }
                        </span>
                    </button>
                    <Collapse in={this.state.ShowDropdown}>

                        <div className="css-1pcexqc-container" id="AuthorPublication">
                            <div className="css-1jllj6i-control">


                                <input style={{
                                    fontSize: '14px',
                                    minHeight: '30px', outline: '0', backgroundColor: '#FFFFFF', border: 'none', color: '#474747', textIndent: '8px'
                                }}
                                    value={this.state.searchtextboxvalue}
                                    type="text"
                                    placeholder="Enter author"
                                    title="Type the author that you want to use as filter" 
                                    onChange={this.filterList.bind(this)}
                                />

                                {(this.state.ShowCrossButton == true) ?
                                    <div className="css-1wy0on6">
                                        <div style={{ color: 'rgb(204, 204, 204)', height: '30px', width: '25px', fontSize: '25px' }}>
                                            <MdCancel onClick={this.ClearSearchBox} />
                                        </div>
                                    </div>
                                    :
                                    null}
                            </div>

                             
                            <div ref={this.myRef} className="css-ik6y5r Scrollsearchmenu" onScroll={this.onScroll}>
                                {this.renderList()}

                            </div>

                        </div>

                    </Collapse>
                </div>

            </div>
        )
    }
}

export default MultiSelectCheckbox;



// WEBPACK FOOTER //
// ./src/components/Home/MultiSelectCheckbox.jsx